// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css */
.app {
  font-family: Arial, sans-serif;
}

.row {
  width: 100%;
  padding: 0vh 0; /* Using vh for vertical padding */
  box-sizing: border-box;
}

.row-1 .full-width-image {
  width: 100%;
  height: auto;
}

.row-1-mobile .mobile-width-image {
  width: 100%;
  height: auto;
  display: none; /* Hide top row */
}

.row-2 {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: white;
  padding: 0vh 0;
  position: relative;
}

.row-3 {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: #183340;
  color: white;
  padding: 2vh 0;
  position: relative;
}

.footer-row {
  height: 5vh;
  background-color: #183340;
}

.text-container-1,
.text-container-2 {
  width: 40vw; /* Adjust width as needed */
  max-width: 40vw; /* Adjust max-width as needed, using vw */
  margin-left: 15vw; /* Move slightly to the left */
  padding: 2vh; /* Using vh for padding */
  box-sizing: border-box;
}

.text-container-1 {
  text-align: center; /* Center justify text */
}

.text-container-1 h3 {
  color: grey; /* Make h3 text grey */
}

.text-container-1 h2 {
  color: #183340; /* Make h3 text grey */
}

.text-container-2 {
  text-align: left; /* Ensure left alignment */
}

.bold-text {
  font-weight: bold; /* Make this specific paragraph bold */
}

.form-wrapper {
  margin-top: 0vh;
  position: absolute;
  top: -20vh;
  right: 15vw; /* Move to the left using vw */
  background-color: white;
  z-index: 2;
  border-radius: 5px;
  padding: 0vh; /* Using vh for padding */;
}

.form-wrapper-mobile {
  margin-top: 0vh;
  position: absolute;
  top: -20vh;
  right: 15vw; /* Move to the left using vw */
  background-color: white;
  z-index: 2;
  border-radius: 5px;
  padding: 0vh; /* Using vh for padding */;
  display: none;
}

.row-4 {
  background-color: white;
  text-align: left;
  padding: 5vh 0; /* Using vh for vertical padding */
}

.footer-logos {
  width: 40%; /* Adjust width as needed */
  max-width: 60vw; /* Adjust max-width as needed, using vw */
  margin-left: 20vw; /* Move to the left using vw */
  padding: 2vh; /* Using vh for padding */
  box-sizing: border-box;
  line-height: 25px;
  justify-content: center;
}

.footer-logos img {
  margin: 0 1vw; /* Using vw for horizontal margin */
  max-height: 5vh; /* Using vh for max-height */
}

.thank-you-message button {
  width: 100%; /* Adjust the width as needed */
  padding: 10px;
  margin-top: 20px; /* Space above the button */
  background-color: white;
  color: #183340;
  border: none;
  cursor: pointer;
  border-radius: 2px;
  font-size: 16px;
}

.thank-you-message {
 
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  background: #183340;
}

.event-card {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  font-family: Arial, sans-serif;
  color: #183340;
}

.event-card h3 {
  color: rgb(248, 2, 2);
  margin-bottom: 1vh;
}

.event-card p {
  margin-top: 0vh;
  margin-bottom: 1vh;
}

.view-map {
  margin-top: 0vh;
  margin-bottom: 1vh;
}

.event-card .tag {
  background-color: #e0e0e0;
  border-radius: 5px;
  padding: 5px;
  display: inline-block;
  margin-bottom: 2px;
}

.date-time p, .location p {
  margin: 5px 0;
  padding-bottom: 2vh;
}

.date-time .add-calendar, .location .view-map {
  color: #f10505;
  text-decoration: none;
}

.secure-text {
  color: #666;
  font-size: 16px;
  text-align: justify;
  margin-top: 15px;
}


/* Adjust spacing for narrower laptop screens */
@media (max-width: 1500px) and (min-width: 1025px) {
  .form-wrapper {
    right: 5vw; /* Decrease right margin */
    top: -25vh;
    width: -moz-fit-content;
    width: fit-content;

  }

  .text-container-1,
  .text-container-2 {
    width: 50%; /* Increase width */
    max-width: 50vw; /* Increase max-width */
    margin-left: 10vw; /* Adjust left margin */
  }

}

/* For Tablets */

@media (max-width: 1366px) and (min-width: 768px) {
  .row-1 {
    display: none; /* Hide top row */
  }

  .row-1-mobile .mobile-width-image {
    width: 100%;
    height: auto;
    display: block; /* Hide top row */
  }

  .row-2 {
    display: flex;
    flex-direction: column;
    align-items: center; /* Center contents */

  }

  .text-container-1,
  .text-container-2 {
    width: 90%; /* Full width for mobile */
    max-width: 90vw;
    margin: 0 auto;
  }

  p {
    font-size: 35px !important;
  }
  
  h2 {
    font-size: 60px !important;
  }

  h3 {
    font-size: 40px !important;
  }

.form-wrapper {
  position: static;
  margin: 5vh auto; /* Center horizontally and add vertical margin for spacing */
  max-width: 100vw;
  justify-content: center;
  display: flex; /* Use flexbox for centering */
  flex-direction: column; /* Ensure content is stacked vertically */
  align-items: center; /* Center content horizontally */
}

  .row-3 {
    display: flex;
    flex-direction: column;
    align-items: center; /* Center contents */
    width: 100%;

  }
  .thank-you-message {
    font-size: 30px;
    display: flex;
    flex-direction: column;
    align-items: center; /* Center align items horizontally */
    justify-content: center; /* Center align items vertically */
    text-align: center; /* Center align text */
  }
  
  .thank-you-message button {
    width: 100%; /* Adjust the width as needed */
    padding: 10px;
    margin-top: 20px !important; /* Space above the button */
    border-radius: 5px !important;
    font-size: 30px !important;
  }
}

/* For Mobile Phones */

@media (max-width: 767px) {

  .row-1-mobile .mobile-width-image {
    width: 100%;
    height: auto;
    display: block; /* Hide top row */
  }

  .row-1 {
    display: none; /* Hide top row */
  }

  .row-2 {
    display: flex;
    flex-direction: column;
    align-items: center; /* Center contents */
   
  }

  .text-container-1,
  .text-container-2 {
    width: 95%; /* Full width for mobile */
    max-width: 100vw;
    margin: 0 auto;
    font-size: 20px;
  }

  .form-wrapper {
    position: static;

    width: 100%;
    max-width: 100vw;
  }

  .row-3 {
    display: flex;
    flex-direction: column;
    align-items: center; /* Center contents */
    width: 100%;
    padding: 5vh 0;
  }
  .thank-you-message {
    font-size: 30px;
    display: flex;
    flex-direction: column;
    align-items: center; /* Center align items horizontally */
    justify-content: center; /* Center align items vertically */
    text-align: center; /* Center align text */
  }
  
  .thank-you-message button {
    width: 100%; /* Adjust the width as needed */
    padding: 10px;
    margin-top: 20px !important; /* Space above the button */
    border-radius: 5px !important;
    font-size: 30px !important;
  }
}



`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,cAAc,EAAE,kCAAkC;EAClD,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa,EAAE,iBAAiB;AAClC;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW,EAAE,2BAA2B;EACxC,eAAe,EAAE,yCAAyC;EAC1D,iBAAiB,EAAE,8BAA8B;EACjD,YAAY,EAAE,yBAAyB;EACvC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB,EAAE,wBAAwB;AAC9C;;AAEA;EACE,WAAW,EAAE,sBAAsB;AACrC;;AAEA;EACE,cAAc,EAAE,sBAAsB;AACxC;;AAEA;EACE,gBAAgB,EAAE,0BAA0B;AAC9C;;AAEA;EACE,iBAAiB,EAAE,sCAAsC;AAC3D;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,WAAW,EAAE,8BAA8B;EAC3C,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,YAAY,EAAE,yBAAyB;AACzC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,WAAW,EAAE,8BAA8B;EAC3C,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,YAAY,EAAE,yBAAyB;EACvC,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc,EAAE,kCAAkC;AACpD;;AAEA;EACE,UAAU,EAAE,2BAA2B;EACvC,eAAe,EAAE,yCAAyC;EAC1D,iBAAiB,EAAE,8BAA8B;EACjD,YAAY,EAAE,yBAAyB;EACvC,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa,EAAE,mCAAmC;EAClD,eAAe,EAAE,4BAA4B;AAC/C;;AAEA;EACE,WAAW,EAAE,+BAA+B;EAC5C,aAAa;EACb,gBAAgB,EAAE,2BAA2B;EAC7C,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;;AAGA,+CAA+C;AAC/C;EACE;IACE,UAAU,EAAE,0BAA0B;IACtC,UAAU;IACV,uBAAkB;IAAlB,kBAAkB;;EAEpB;;EAEA;;IAEE,UAAU,EAAE,mBAAmB;IAC/B,eAAe,EAAE,uBAAuB;IACxC,iBAAiB,EAAE,uBAAuB;EAC5C;;AAEF;;AAEA,gBAAgB;;AAEhB;EACE;IACE,aAAa,EAAE,iBAAiB;EAClC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc,EAAE,iBAAiB;EACnC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,oBAAoB;;EAE3C;;EAEA;;IAEE,UAAU,EAAE,0BAA0B;IACtC,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;AAEF;EACE,gBAAgB;EAChB,gBAAgB,EAAE,4DAA4D;EAC9E,gBAAgB;EAChB,uBAAuB;EACvB,aAAa,EAAE,8BAA8B;EAC7C,sBAAsB,EAAE,yCAAyC;EACjE,mBAAmB,EAAE,gCAAgC;AACvD;;EAEE;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,oBAAoB;IACzC,WAAW;;EAEb;EACA;IACE,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,oCAAoC;IACzD,uBAAuB,EAAE,kCAAkC;IAC3D,kBAAkB,EAAE,sBAAsB;EAC5C;;EAEA;IACE,WAAW,EAAE,+BAA+B;IAC5C,aAAa;IACb,2BAA2B,EAAE,2BAA2B;IACxD,6BAA6B;IAC7B,0BAA0B;EAC5B;AACF;;AAEA,sBAAsB;;AAEtB;;EAEE;IACE,WAAW;IACX,YAAY;IACZ,cAAc,EAAE,iBAAiB;EACnC;;EAEA;IACE,aAAa,EAAE,iBAAiB;EAClC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,oBAAoB;;EAE3C;;EAEA;;IAEE,UAAU,EAAE,0BAA0B;IACtC,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,gBAAgB;;IAEhB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,oBAAoB;IACzC,WAAW;IACX,cAAc;EAChB;EACA;IACE,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,oCAAoC;IACzD,uBAAuB,EAAE,kCAAkC;IAC3D,kBAAkB,EAAE,sBAAsB;EAC5C;;EAEA;IACE,WAAW,EAAE,+BAA+B;IAC5C,aAAa;IACb,2BAA2B,EAAE,2BAA2B;IACxD,6BAA6B;IAC7B,0BAA0B;EAC5B;AACF","sourcesContent":["/* App.css */\n.app {\n  font-family: Arial, sans-serif;\n}\n\n.row {\n  width: 100%;\n  padding: 0vh 0; /* Using vh for vertical padding */\n  box-sizing: border-box;\n}\n\n.row-1 .full-width-image {\n  width: 100%;\n  height: auto;\n}\n\n.row-1-mobile .mobile-width-image {\n  width: 100%;\n  height: auto;\n  display: none; /* Hide top row */\n}\n\n.row-2 {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  background-color: white;\n  padding: 0vh 0;\n  position: relative;\n}\n\n.row-3 {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  background-color: #183340;\n  color: white;\n  padding: 2vh 0;\n  position: relative;\n}\n\n.footer-row {\n  height: 5vh;\n  background-color: #183340;\n}\n\n.text-container-1,\n.text-container-2 {\n  width: 40vw; /* Adjust width as needed */\n  max-width: 40vw; /* Adjust max-width as needed, using vw */\n  margin-left: 15vw; /* Move slightly to the left */\n  padding: 2vh; /* Using vh for padding */\n  box-sizing: border-box;\n}\n\n.text-container-1 {\n  text-align: center; /* Center justify text */\n}\n\n.text-container-1 h3 {\n  color: grey; /* Make h3 text grey */\n}\n\n.text-container-1 h2 {\n  color: #183340; /* Make h3 text grey */\n}\n\n.text-container-2 {\n  text-align: left; /* Ensure left alignment */\n}\n\n.bold-text {\n  font-weight: bold; /* Make this specific paragraph bold */\n}\n\n.form-wrapper {\n  margin-top: 0vh;\n  position: absolute;\n  top: -20vh;\n  right: 15vw; /* Move to the left using vw */\n  background-color: white;\n  z-index: 2;\n  border-radius: 5px;\n  padding: 0vh; /* Using vh for padding */;\n}\n\n.form-wrapper-mobile {\n  margin-top: 0vh;\n  position: absolute;\n  top: -20vh;\n  right: 15vw; /* Move to the left using vw */\n  background-color: white;\n  z-index: 2;\n  border-radius: 5px;\n  padding: 0vh; /* Using vh for padding */;\n  display: none;\n}\n\n.row-4 {\n  background-color: white;\n  text-align: left;\n  padding: 5vh 0; /* Using vh for vertical padding */\n}\n\n.footer-logos {\n  width: 40%; /* Adjust width as needed */\n  max-width: 60vw; /* Adjust max-width as needed, using vw */\n  margin-left: 20vw; /* Move to the left using vw */\n  padding: 2vh; /* Using vh for padding */\n  box-sizing: border-box;\n  line-height: 25px;\n  justify-content: center;\n}\n\n.footer-logos img {\n  margin: 0 1vw; /* Using vw for horizontal margin */\n  max-height: 5vh; /* Using vh for max-height */\n}\n\n.thank-you-message button {\n  width: 100%; /* Adjust the width as needed */\n  padding: 10px;\n  margin-top: 20px; /* Space above the button */\n  background-color: white;\n  color: #183340;\n  border: none;\n  cursor: pointer;\n  border-radius: 2px;\n  font-size: 16px;\n}\n\n.thank-you-message {\n \n  color: white;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  background: #183340;\n}\n\n.event-card {\n  background: #fff;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 5px rgba(0,0,0,0.1);\n  font-family: Arial, sans-serif;\n  color: #183340;\n}\n\n.event-card h3 {\n  color: rgb(248, 2, 2);\n  margin-bottom: 1vh;\n}\n\n.event-card p {\n  margin-top: 0vh;\n  margin-bottom: 1vh;\n}\n\n.view-map {\n  margin-top: 0vh;\n  margin-bottom: 1vh;\n}\n\n.event-card .tag {\n  background-color: #e0e0e0;\n  border-radius: 5px;\n  padding: 5px;\n  display: inline-block;\n  margin-bottom: 2px;\n}\n\n.date-time p, .location p {\n  margin: 5px 0;\n  padding-bottom: 2vh;\n}\n\n.date-time .add-calendar, .location .view-map {\n  color: #f10505;\n  text-decoration: none;\n}\n\n.secure-text {\n  color: #666;\n  font-size: 16px;\n  text-align: justify;\n  margin-top: 15px;\n}\n\n\n/* Adjust spacing for narrower laptop screens */\n@media (max-width: 1500px) and (min-width: 1025px) {\n  .form-wrapper {\n    right: 5vw; /* Decrease right margin */\n    top: -25vh;\n    width: fit-content;\n\n  }\n\n  .text-container-1,\n  .text-container-2 {\n    width: 50%; /* Increase width */\n    max-width: 50vw; /* Increase max-width */\n    margin-left: 10vw; /* Adjust left margin */\n  }\n\n}\n\n/* For Tablets */\n\n@media (max-width: 1366px) and (min-width: 768px) {\n  .row-1 {\n    display: none; /* Hide top row */\n  }\n\n  .row-1-mobile .mobile-width-image {\n    width: 100%;\n    height: auto;\n    display: block; /* Hide top row */\n  }\n\n  .row-2 {\n    display: flex;\n    flex-direction: column;\n    align-items: center; /* Center contents */\n\n  }\n\n  .text-container-1,\n  .text-container-2 {\n    width: 90%; /* Full width for mobile */\n    max-width: 90vw;\n    margin: 0 auto;\n  }\n\n  p {\n    font-size: 35px !important;\n  }\n  \n  h2 {\n    font-size: 60px !important;\n  }\n\n  h3 {\n    font-size: 40px !important;\n  }\n\n.form-wrapper {\n  position: static;\n  margin: 5vh auto; /* Center horizontally and add vertical margin for spacing */\n  max-width: 100vw;\n  justify-content: center;\n  display: flex; /* Use flexbox for centering */\n  flex-direction: column; /* Ensure content is stacked vertically */\n  align-items: center; /* Center content horizontally */\n}\n\n  .row-3 {\n    display: flex;\n    flex-direction: column;\n    align-items: center; /* Center contents */\n    width: 100%;\n\n  }\n  .thank-you-message {\n    font-size: 30px;\n    display: flex;\n    flex-direction: column;\n    align-items: center; /* Center align items horizontally */\n    justify-content: center; /* Center align items vertically */\n    text-align: center; /* Center align text */\n  }\n  \n  .thank-you-message button {\n    width: 100%; /* Adjust the width as needed */\n    padding: 10px;\n    margin-top: 20px !important; /* Space above the button */\n    border-radius: 5px !important;\n    font-size: 30px !important;\n  }\n}\n\n/* For Mobile Phones */\n\n@media (max-width: 767px) {\n\n  .row-1-mobile .mobile-width-image {\n    width: 100%;\n    height: auto;\n    display: block; /* Hide top row */\n  }\n\n  .row-1 {\n    display: none; /* Hide top row */\n  }\n\n  .row-2 {\n    display: flex;\n    flex-direction: column;\n    align-items: center; /* Center contents */\n   \n  }\n\n  .text-container-1,\n  .text-container-2 {\n    width: 95%; /* Full width for mobile */\n    max-width: 100vw;\n    margin: 0 auto;\n    font-size: 20px;\n  }\n\n  .form-wrapper {\n    position: static;\n\n    width: 100%;\n    max-width: 100vw;\n  }\n\n  .row-3 {\n    display: flex;\n    flex-direction: column;\n    align-items: center; /* Center contents */\n    width: 100%;\n    padding: 5vh 0;\n  }\n  .thank-you-message {\n    font-size: 30px;\n    display: flex;\n    flex-direction: column;\n    align-items: center; /* Center align items horizontally */\n    justify-content: center; /* Center align items vertically */\n    text-align: center; /* Center align text */\n  }\n  \n  .thank-you-message button {\n    width: 100%; /* Adjust the width as needed */\n    padding: 10px;\n    margin-top: 20px !important; /* Space above the button */\n    border-radius: 5px !important;\n    font-size: 30px !important;\n  }\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
